const prefix = 'lumahealth/App';

export const NEXTY_NEXT_VERSION_STORAGE_KEY = (userId) => `lh:ui-nexty:${userId}:enabled`;
export const NEXTY_BANNER_STORAGE_KEY = (userId) => `lh:ui-nexty:${userId}:hide-banner`;

export const GET_BROADCASTS_COUNT = `${prefix}/GET_BROADCASTS_COUNT`;
export const GET_BROADCASTS_COUNT_ERROR = `${prefix}/GET_BROADCASTS_COUNT_ERROR`;
export const GET_BROADCASTS_COUNT_SUCCESS = `${prefix}/GET_BROADCASTS_COUNT_SUCCESS`;
export const NEXTGEN_ENV_REGEX = /next\.nextgen\.lumahealthdemo\.com/;

export const GET_DOWNTIME_MESSAGE = `${prefix}/GET_DOWNTIME_MESSAGE`;
export const GET_DOWNTIME_MESSAGE_SUCCESS = `${prefix}/GET_DOWNTIME_MESSAGE_SUCCESS`;

export const GET_LANGUAGES = `${prefix}/GET_LANGUAGES`;
export const GET_LANGUAGES_ERROR = `${prefix}/GET_LANGUAGES_ERROR`;
export const GET_LANGUAGES_SUCCESS = `${prefix}/GET_LANGUAGES_SUCCESS`;

export const CLEAR_NOTIFICATION = `${prefix}/CLEAR_NOTIFICATION`;

export const CLOSE_WEB_NOTIFICATION = `${prefix}/CLOSE_WEB_NOTIFICATION`;

export const EMIT_SOCKET_TYPING = `${prefix}/EMIT_SOCKET_TYPING`;

export const HIDE_EXPIRING_PASSWORD_ALERT = `${prefix}/HIDE_EXPIRING_PASSWORD_ALERT`;

export const IGNORE_WEB_NOTIFICATION = `${prefix}/IGNORE_WEB_NOTIFICATION`;

export const LOAD_INTAKE_FORMS_SQUIGGLIES = `${prefix}/LOAD_INTAKE_FORMS_SQUIGGLIES_USER`;
export const LOAD_INTAKE_FORMS_SQUIGGLIES_ERROR = `${prefix}/LOAD_INTAKE_FORMS_SQUIGGLIES_ERROR`;
export const LOAD_INTAKE_FORMS_SQUIGGLIES_SUCCESS = `${prefix}/LOAD_INTAKE_FORMS_SQUIGGLIES_SUCCESS`;

export const LOAD_MASTER_USER = `${prefix}/LOAD_MASTER_USER`;
export const LOAD_MASTER_USER_ERROR = `${prefix}/LOAD_MASTER_USER_ERROR`;
export const LOAD_MASTER_USER_SUCCESS = `${prefix}/LOAD_MASTER_USER_SUCCESS`;

export const LOAD_WIDGET_USER_SUCCESS = `${prefix}/LOAD_WIDGET_USER_SUCCESS`;
export const LOAD_WIDGET_USER_ERROR = `${prefix}/LOAD_WIDGET_USER_ERROR`;
export const LOAD_WIDGET_USER = `${prefix}/LOAD_WIDGET_USER`;

export const CHC_LOGO =
  'https://marketplace.changehealthcare.com/explore-catalog/_jcr_content/root/main-par/header/desktopDefaultImage.coreimg.svg/1644861869529/ch-logo-94px.svg';
export const CHC_LOGO_WHITE =
  'https://newsroom.changehealthcare.com/content/dam/change-healthcare/corporate-site-2021/global/logo/ch-logo-94px-white.svg';
export const LUMA_LOGO = 'https://lumahealth-assets.s3.us-west-2.amazonaws.com/new_luma_logo_black.png';
export const LUMA_LOGO_WHITE = 'https://lumahealth-assets.s3.us-west-2.amazonaws.com/new_luma_logo_white.png';

export const ON_SOCKET_ACTIVITY = `${prefix}/ON_SOCKET_ACTIVITY`;
export const ON_SOCKET_AVAILABILITY = `${prefix}/ON_SOCKET_AVAILABILITY`;
export const ON_SOCKET_BROADCAST_UPDATE = `${prefix}/ON_SOCKET_BROADCAST_UPDATE`;
export const ON_SOCKET_HAS_NEW_ACTIVITY = `${prefix}/ON_SOCKET_HAS_NEW_ACTIVITY`;
export const ON_SOCKET_MESSAGE = `${prefix}/ON_SOCKET_MESSAGE`;
export const ON_SOCKET_OFFER = `${prefix}/ON_SOCKET_OFFER`;
export const ON_SOCKET_REFERRAL_PENDING = `${prefix}/ON_SOCKET_REFERRAL_PENDING`;
export const ON_SOCKET_CHAT_ACTIVITY = `${prefix}/ON_SOCKET_CHAT_ACTIVITY`;

export const ON_SOCKET_TELEHEALTH_STATUS_UPDATE = `${prefix}/ON_SOCKET_TELEHEALTH_STATUS_UPDATE`;
export const ON_SOCKET_TELEHEALTH = `${prefix}/ON_SOCKET_TELEHEALTH`;

export const ON_SOCKET_UPLOAD_APPOINTMENT_UPDATE = `${prefix}/ON_SOCKET_UPLOAD_APPOINTMENT_UPDATE`;
export const ON_SOCKET_UPLOAD_PATIENT_UPDATE = `${prefix}/ON_SOCKET_UPLOAD_PATIENT_UPDATE`;
export const ON_SOCKET_UPLOAD_RECALL_UPDATE = `${prefix}/ON_SOCKET_UPLOAD_RECALL_UPDATE`;
export const ON_SOCKET_UPLOAD_REFERRAL_UPDATE = `${prefix}/ON_SOCKET_UPLOAD_REFERRAL_UPDATE`;
export const ON_SOCKET_UPLOAD_UPDATE = `${prefix}/ON_SOCKET_UPLOAD_UPDATE`;
export const ON_SOCKET_USER_UPDATE = `${prefix}/ON_SOCKET_USER_UPDATE`;

export const ON_SOCKET_WAITING_ROOM_PATIENT_CREATE = `${prefix}/ON_SOCKET_WAITING_ROOM_PATIENT_CREATE`;
export const ON_SOCKET_WAITING_ROOM_PATIENT_UPDATE = `${prefix}/ON_SOCKET_WAITING_ROOM_PATIENT_UPDATE`;

export const ON_SOCKET_WAITING_ROOM_PATIENT_STATUS_UPDATE = `${prefix}/ON_SOCKET_WAITING_ROOM_PATIENT_STATUS_UPDATE`;

export const RESFRESH_CURRENT_USER = `${prefix}/RESFRESH_CURRENT_USER`;

export const REGISTER_SOCKET = `${prefix}/REGISTER_SOCKET`;

export const SET_ACHIEVEMENT_TYPE = `${prefix}/SET_ACHIEVEMENT_TYPE`;

export const SHOW_MESSAGE = `${prefix}/SHOW_MESSAGE`;

export const SHOW_EXPIRING_PASSWORD_ALERT = `${prefix}/SHOW_EXPIRING_PASSWORD_ALERT`;

export const SHOW_WEB_NOTIFICATION = `${prefix}/SHOW_WEB_NOTIFICATION`;

export const WEB_NOTIFICATION_SHOWED = `${prefix}/WEB_NOTIFICATION_SHOWED`;

export const ON_SOCKET_PRESENCE_USER_ONLINE = `${prefix}/ON_SOCKET_PRESENCE_USER_ONLINE`;

export const ON_SOCKET_PRESENCE_USER_OFFLINE = `${prefix}/ON_SOCKET_PRESENCE_USER_OFFLINE`;

export const LOAD_PATIENT_JOURNEY = `${prefix}/LOAD_PATIENT_JOURNEY`;
export const LOAD_PATIENT_JOURNEY_SUCCESS = `${prefix}/LOAD_PATIENT_JOURNEY_SUCCESS`;
export const LOAD_PATIENT_JOURNEY_ERROR = `${prefix}/LOAD_PATIENT_JOURNEY_ERROR`;
